import { useEffect, useState } from 'react';

const MOBILE_BREAKPOINT = 640;
const TABLET_BREAKPOINT = 1024;
const DESKTOP_BREAKPOINT = 1500;
const WIDE_BREAKPOINT = 2200;

const getMaxColumns = (width) => {
  if (width < MOBILE_BREAKPOINT) return 1;
  if (width < TABLET_BREAKPOINT) return 2;
  if (width <= DESKTOP_BREAKPOINT) return 3;
  if (width <= WIDE_BREAKPOINT) return 4;
  return 5;
};

const useGridColumns = () => {
  const [columns, setColumns] = useState(() => getMaxColumns(window.innerWidth));

  useEffect(() => {
    const handleResize = () => {
      setColumns(getMaxColumns(window.innerWidth));
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return columns;
};

export default useGridColumns;
